define.alias("shared/components/shared-ig-media-card", "media/components/shared-ig-media-card");